import { Trans } from "@lingui/react/macro";
import { Button, Modal, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus } from "@tabler/icons-react";

import { CreateLocationForm } from "./create-location-form";

export default function CreateLocation() {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Button onClick={open} leftSection={<IconPlus />}>
        <Trans>Opprett lokasjon</Trans>
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        size="lg"
        title={
          <Title component="span" size="sm">
            <Trans>Opprett lokasjon</Trans>
          </Title>
        }
      >
        <CreateLocationForm onSuccess={close} onCancel={close} />
      </Modal>
    </>
  );
}
